
export default {
  name: 'EoLogoAnbi',
  props: {
    /**
     * Size of the icon: (xs) (sm) (md) (lg) (xl)
     */
    size: {
      type: String,
      default: '',
    },
    /**
     * Style: hex value of color
     */
    color: {
      type: String,
      default: '',
    },
  },
}
